import React, { useState, useEffect } from 'react';
import prettyBytes from 'pretty-bytes';
import ResponseTabGroup from '../../Tab-Groups/ResponseTabGroup';

export default function Response({ response, loading, setResponse }) {
  const [doc, setDoc] = useState('{}');

  useEffect(() => {
    if (response === null) return;
    const jsonResponse = JSON.stringify(response.data, null, 2);
    setDoc(jsonResponse);
  }, [response, loading]);

  const hasResponse = !(response == null);

  let time = '';
  let status = '';
  let size = '';

  if (hasResponse) {
    const hasCustomData = 'customData' in response;
    const hasData = 'data' in response;
    const hasHeaders = 'headers' in response;

    status = hasResponse ? response.status : 0;

    if (hasData && hasHeaders) {
      size = prettyBytes(
        (hasResponse ? JSON.stringify(response.data).length : 0) +
          (hasResponse ? JSON.stringify(response.headers).length : 0)
      );
    }

    if (hasCustomData) {
      time = response.customData.time;
    }
  }

  const handleClear = () => {
    setDoc('{}'); // Reset response body to empty JSON
    setResponse(null); // Clear response to remove headers and meta
  };

  const RenderedResponseMeta = () => {
    return (
      <div className="flex items-center mt-2">
        <span className="w-24 text-sm">Status: {status}</span>
        <span className="w-20 text-sm">Time: {time}</span>
        <span className="w-20 text-sm">Size: {size}</span>
        <button
          className="ml-auto p-2 rounded-lg text-[#fdb814] border-2 border-[#fdb814] hover:bg-gradient-to-r hover:from-[#fdb814] hover:to-[#e5a50f] hover:text-white transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-4 focus:ring-[#fdb814]/30"
          onClick={handleClear}
          title="Clear Response"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1-1H9a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </button>
      </div>
    );
  };

  return (
    <div className="my-3">
      <span className="text-lg font-medium">Response</span>
      {response ? <RenderedResponseMeta /> : null}
      <ResponseTabGroup
        doc={doc}
        setDoc={setDoc}
        response={response}
        setResponse={setResponse}
        loading={loading}
      />
    </div>
  );
}